import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { OfferListingStatus } from '@steelbuy/ts-shared';

export interface SearchResultsContextValue {
    filter: OfferListingStatus[];
    setFilter: (filter: OfferListingStatus[]) => void;
}

const defaultValue: SearchResultsContextValue = {
    filter: [],
    setFilter: () => null,
};

const ManageOffersContext = createContext(defaultValue);

export const ManageOffersContextProvider = ({ children }: { children: ReactNode }) => {
    const [filter, setFilter] = useState<OfferListingStatus[]>([]);
    const value = useMemo(
        () => ({
            filter,
            setFilter,
        }),
        [filter, setFilter]
    );

    return <ManageOffersContext.Provider value={value}>{children}</ManageOffersContext.Provider>;
};

export const useManageOffersContext = () => useContext(ManageOffersContext);
